export default __webpack_public_path__ + "static/media/wallet-product-borrow.4ed342e4.svg";